<script setup>
const props = defineProps(['column', 'sort']);
const emit = defineEmits('changeSort');

function changeSort(field) {
    let sort = {
        field: "",
        dir: "",
    }

    if (props.sort.field === field) {
        if (props.sort.dir === 'asc') {
            sort.field = field
            sort.dir = "desc"
        } else {
            sort.field = ""
            sort.dir = ""
        }
    } else {
        sort.field = field
        sort.dir = "asc"
    }

    emit('changeSort', sort)
}
</script>

<template>
    <th :class="{'main-table__title__sortable': sort.field === column.name}" :title="column.label">
        <div class="main-table__title" @click="changeSort(column.name)">
            {{column.label}}

            <a v-if="sort.field === column.name && sort.dir === 'asc'"><i class="chevron-up active"></i></a>
            <a v-if="sort.field === column.name && sort.dir === 'desc'"><i class="chevron-down active"></i></a>
            <a v-if="sort.field !== column.name" class="main-table__title__arrow"><i class="chevron-down"></i></a>
        </div>
    </th>
</template>

<style scoped>

</style>
